(function(Manogi, $, undefined) {

    //Private

    //Public



    Manogi.scrollToFirstHighlighted = function() {
        $first_error = $('.u-error').first();
        Manogi.scrollToElement($first_error);
    };

    Manogi.removeAllErrors = function($form) {
        $form.find('input, select, textarea').removeClass('u-error');
        $form.find('.js-message').removeClass('u-error').text('');
    };




}( window.Manogi = window.Manogi || {}, jQuery ));
